import React from 'react';
import { useSelector } from 'react-redux';
import { Helmet } from 'react-helmet';
import { ConfigurationSchema } from 'frontastic-common';
import { useMountedState } from 'react-use';
export const HomePageSchema = () => {
  const isMounted = useMountedState();
  const context = useSelector((state) => state.app.context);
  const storeUrl = context.projectConfiguration['EXTENSION_PUBLIC_URL'];

  const projectSchema = new ConfigurationSchema(
    context.projectConfigurationSchema,
    context.projectConfiguration,
  );

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    url: `${storeUrl}`,
    potentialAction: [
      {
        '@type': 'SearchAction',
        target: {
          '@type': 'EntryPoint',
          urlTemplate: `${storeUrl}/q/{search_term_string}`,
        },
        'query-input': 'required name=search_term_string',
      },
    ],
  };

  return (
    <>
      <Helmet>
        <meta
          name="description"
          content={
            projectSchema.get('schemaSiteDescription')?.[context.locale] ||
            projectSchema.get('schemaSiteDescription')
          }
        />

        <meta property="og:url" content={storeUrl} />
        <meta property="og:image" content={`${storeUrl}/logo.png`} />
        <meta property="og:type" content="website" />
        <meta
          property="og:site_name"
          content={projectSchema.get('schemaOrgName')}
        />
        <meta property="og:locale" content="en-AU" />
        <meta
          property="og:title"
          content={
            projectSchema.get('schemaSiteTitle')?.[context.locale] ||
            projectSchema.get('schemaSiteTitle')
          }
        />
        <meta
          property="og:description"
          content={
            projectSchema.get('schemaSiteDescription')?.[context.locale] ||
            projectSchema.get('schemaSiteDescription')
          }
        />
        <meta property="og:country-name" content="au" />
      </Helmet>
      {isMounted() && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
        />
      )}
    </>
  );
};
